"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOnDemandPayoutSupportedCountry = void 0;
const country_1 = require("../enums/country");
const ON_DEMAND_PAYOUT_SUPPORTED_COUNTRIES = [
    country_1.OrganizationCountry.UnitedStates,
    country_1.OrganizationCountry.Canada,
    country_1.OrganizationCountry.GreatBritain,
    country_1.OrganizationCountry.Australia,
    country_1.OrganizationCountry.Ireland,
    country_1.OrganizationCountry.Germany,
];
const isOnDemandPayoutSupportedCountry = (country) => country !== null && country !== undefined && ON_DEMAND_PAYOUT_SUPPORTED_COUNTRIES.includes(country);
exports.isOnDemandPayoutSupportedCountry = isOnDemandPayoutSupportedCountry;
